import React from 'react';
import ProgressBar from './ProgressBar';
const MapModal = ({ children, footerChildren, isOpen, progressBarDescription, progressBarPercent = null, onClose, showClose = true, className, inline }) => {
    return isOpen ? (React.createElement("div", { className: 'cm-modal' + (className !== '' ? ' ' + className : '') },
        React.createElement("div", { className: `cm-modal__overlay ${inline ? 'cm-modal__overlay-inline' : ''}` },
            React.createElement("div", { className: "cm-modal__container" },
                progressBarPercent !== null && progressBarDescription && (React.createElement(ProgressBar, { description: progressBarDescription, percent: progressBarPercent })),
                React.createElement("div", { className: "cm-modal__content" },
                    showClose && (React.createElement("button", { className: "cm-modal__close-btn", onClick: onClose },
                        React.createElement("i", { className: "fa-solid fa-xmark" }),
                        React.createElement("span", { className: "sr-only" }, "Close"))),
                    children),
                footerChildren && React.createElement("div", { className: "cm-modal__footer" }, footerChildren))))) : (React.createElement("div", null));
};
export default MapModal;
